import DatatableHelperMixin from "../../../../common/Mixin/Global/DatatableHelperMixin";
import {COURSE, LESSON} from "../../../Config/ApiUrl";
import {formatDateTimeToLocalDate} from "../../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('courses.title'),
                url: this.props.employeeId !== undefined
                    ? `${COURSE}?employee_id=${this.props.employeeId}`
                    : COURSE,
                showHeader: true,
                showCount: true,
                tableShadow:false,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'text',
                        key: 'title',
                        isVisible: true,
                    },
                    {
                        title: this.$t('description'),
                        type: 'text',
                        key: 'description',
                        isVisible: true,
                    },
                    {
                        title: this.$t('courses.passing_score'),
                        type: 'text',
                        key: 'passing_score',
                        isVisible: true,
                    },
                    {
                        title: this.$t('created'),
                        type: 'custom-html',
                        key: 'created_at',
                        isVisible: true,
                        modifier: (value) => {
                            return formatDateTimeToLocalDate(value);
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        isVisible: true
                    },
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                ],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                showAction: true,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [
                    {
                        title: this.$t('edit'),
                        type: 'modal',
                        component: 'app-course-modal',
                        modalId: 'course-modal',
                        url: COURSE,
                        name: 'edit',
                        modifier: row => this.$can('update_course')
                    },
                    {
                        title: this.$t('delete'),
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'course-modal',
                        url: COURSE,
                        name: 'delete',
                        modifier: row => this.$can('delete_course')
                    },
                    {
                        title: this.$t('view_details'),
                        key: "view_details",
                        name: 'view_details',
                        url: COURSE,
                    },
                    {
                        title: this.$t('lessons.start_lesson'),
                        name: 'start_lesson',
                        modifier: row => {
                            const userId = this.$store.getters.getUserInformation?.id;
                            const hasLessons = Array.isArray(row.lessons) && row.lessons.length > 0;
                            const hasQuestions = row.lessons?.some(
                                lesson => Array.isArray(lesson.questions) && lesson.questions.length > 0
                            );
                            const userHasProgress = Array.isArray(row.user_course_progress) &&
                                row.user_course_progress.some(
                                    progress => progress.user_id === userId && progress.status.name === 'status_passed'
                                );

                            if(userHasProgress){
                                const attemptCount = row.user_course_progress.length;
                                return !userHasProgress && attemptCount <= 3 && hasLessons && hasQuestions;
                            }
                            return !userHasProgress && hasLessons && hasQuestions;
                        }
                    }
                ],
            }
        }
    },
    created() {
        this.$store.dispatch('getUserInformation');
    }

}
